import {fetchQuery, GraphQLTaggedNode} from 'relay-runtime';
import environment from '../../../RelayEnvironment';
import {useState} from 'react';
import {noop} from 'lodash';

export const useForecastFetchQuery = <DataType, VariablesType extends Record<string, unknown>>(
	query: GraphQLTaggedNode,
	clearDataOnFetch = false,
	// Mission Control pages keep their own Relay store (RelayEnvironment.getInstanceMC); fetching
	// into it is what lets an imperative refetch update the page's fragments.
	isMc = false
): {
	data: DataType | null;
	fetch: (variables?: VariablesType, onSuccess?: () => void, onError?: () => void) => void;
	loading: boolean;
} => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState<DataType | null>(null);

	const fetch = (variables = {}, onSuccess = noop, onError = noop) => {
		setLoading(true);
		if (clearDataOnFetch) {
			setData(null);
		}
		fetchQuery(isMc ? environment.getInstanceMC() : environment.getInstance(), query, variables)
			.toPromise()
			.then(
				data => {
					setData(data as DataType);
					setLoading(false);
					onSuccess();
				},
				() => {
					setLoading(false);
					onError();
				}
			);
	};

	return {fetch, data, loading};
};
